module.exports = __webpack_public_path__ + "img/icon-36.8c75da98.svg";